import x from "../../assets/images/X.png";
import { Modal } from "react-bootstrap";
import NotificationMap from "../NotificationMap";
import {
  db,
  collection,
  onSnapshot,
  query,
  where,
  getFirebaseToken,
  updateDoc,
  orderBy,
  doc,
} from "../../utils/firebase/firebase.utils";
import { NOTIFICATION_TYPE_PRODUCT_PRICE_DROP } from "../../constants/constants";
import { useEffect } from "react";
function NotificationModal({
  show,
  setShow,
  users,
  notifications,
  currentUser,
}) {
  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-end d-flex pb-0">
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                src={x}
                alt="main"
                onClick={() => setShow(false)}
                className="x-close ms-1 mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            <ul className="px-0">
              <NotificationMap
                users={users}
                notifications={notifications}
                currentUser={currentUser}
                setShow={setShow}
              />
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NotificationModal;
